import { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

import { LEGEND_ORDER, METRICS } from '../metrics';

/** O que cada número significa, fechado por padrão para não roubar a tela. */
export function MetricLegend() {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-lg border border-gray-200 bg-white">
            <button
                onClick={() => setOpen(!open)}
                className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm text-gray-600 hover:bg-gray-50"
            >
                <HelpCircle className="h-4 w-4 text-gray-400" />
                <span className="font-medium">O que cada número significa</span>
                <ChevronDown
                    className={`ml-auto h-4 w-4 text-gray-400 transition-transform ${
                        open ? 'rotate-180' : ''
                    }`}
                />
            </button>

            {open && (
                <dl className="grid gap-x-8 gap-y-3 border-t border-gray-100 px-4 py-4 sm:grid-cols-2">
                    {LEGEND_ORDER.map((key) => (
                        <div key={key}>
                            <dt className="text-sm font-medium text-gray-900">
                                {METRICS[key].label}
                                <span className="ml-2 font-normal text-gray-400">
                                    {METRICS[key].short}
                                </span>
                            </dt>
                            <dd className="mt-0.5 text-xs leading-relaxed text-gray-500">
                                {METRICS[key].long}
                            </dd>
                        </div>
                    ))}
                </dl>
            )}
        </div>
    );
}
